import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import Page from '../../layout/components/PageAuth.jsx';
import ResetForm from './forms/ResetForm';
import LogoColor from '../../assets/images/logo-master-color.png';
import Footer from '../../layout/components/FooterAuth';
import PageLoader from '../../layout/components/PageLoader';
import http from '../../config/http.js';
import { AUTH_POST_PASSWORD_RESET_VERIFY } from '../../config/api.js';
import RightContent from './common/ContentRightLogin';

function ResetPass() {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token');
  const [loading, setLoading] = useState(true);
  const [valid, setValid] = useState(false);

  const validateToken = async () => {
    try {
      await http.post(AUTH_POST_PASSWORD_RESET_VERIFY, { token });
      setValid(true);
    } catch (e) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    validateToken();
  }, []);

  return (
    <Page title="Change Password">
      <Grid container className="auth_view">
        <Grid item lg={6} md={12} sm={12} xs={12} className="auth_view_content customScrollbar">
          <div className="signup_holder">
            <div className="web_show">
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
          </div>
          <div className="mob_show">
            <div>
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
          </div>
          {loading && <PageLoader />}

          <div className="form_main_content">
            <div className="signup_form_holder">
              <div className="title_reg_right">Change Password</div>
              <p className="subtitle_reg_right web_show">Reset your password.</p>
              {!loading && (!token || !valid) && <p>Link expired</p>}
              {!loading && token && valid && <ResetForm token={token} />}
            </div>
          </div>

          <Footer />
        </Grid>

        <RightContent />
      </Grid>
    </Page>
  );
}

export default ResetPass;
